import React, { useEffect, useState } from "react";
import { api, V1 } from "@/lib/api";

export default function AdminApplications() {
  const [apps, setApps] = useState([]);
  useEffect(() => { api.get(`${V1}/admin/applications`).then((r) => setApps(r.data || [])); }, []);

  return (
    <div className="space-y-6" data-testid="admin-applications-page">
      <div>
        <div className="overline text-accent">Yönetim</div>
        <h1 className="font-display text-3xl font-bold">Tüm Başvurular</h1>
      </div>
      <div className="rounded-xl border border-border bg-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 text-xs uppercase tracking-widest text-muted-foreground">
            <tr>
              <th className="text-left p-3">Başvuru</th>
              <th className="text-left p-3">Okul</th>
              <th className="text-left p-3">Tarih</th>
              <th className="text-left p-3">Durum</th>
            </tr>
          </thead>
          <tbody>
            {apps.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-muted-foreground">Başvuru yok.</td></tr>}
            {apps.map((a) => (
              <tr key={a.id} className="border-t border-border">
                <td className="p-3 font-mono text-xs">{a.application_no}</td>
                <td className="p-3 font-mono text-xs">{a.school_id?.slice(0, 8)}</td>
                <td className="p-3">{new Date(a.created_at).toLocaleDateString("tr-TR")}</td>
                <td className="p-3"><span className="px-2 py-0.5 bg-muted rounded text-xs uppercase">{a.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
